<script lang="ts">
  import { onMount } from 'svelte';

  import { page } from '$app/stores';
  import AppHead from '$lib/components/AppHead.svelte';
  import CookiePolicy from '$lib/components/CookiePolicy.svelte';
  import Drawer from '$lib/components/Drawer.svelte';
  import Header from '$lib/components/Header.svelte';
  import PageViewAnalytics from '$lib/components/Shared/PageViewAnalytics.svelte';
  import Toast from '$lib/components/Shared/Toast.svelte';
  import { DRAWER_NAVBAR } from '$lib/constants/navbar';
  import { sendAnalyticsEvent } from '$lib/services/analytics/index';
  import {
    isToastVisible,
    modalStore,
    toastHeading,
    toastRedirectURL,
    toastSize,
    toastVarient
  } from '$lib/store/index';
  import { EventNames } from '$lib/types/analytics';
  import type { Category } from '$lib/types/category';
  import Logger from '$lib/utils/logger';
  import { PersistentStore } from '$lib/utils/persistent-store';
  import { pwaInfo } from 'virtual:pwa-info';
  import type { PageData } from './$types';
  import GoogleAnalytics from '$lib/services/GoogleAnalytics.svelte';
  import AgeGatingModal from '$lib/components/Shared/Modal/AgeGatingModal.svelte';
  import { AGE_GATING_AGE_GROUP } from '$lib/constants/persistent-store';

  export let data: PageData;

  Logger.log('data', data.locals);

  const noNavRoutes = '/us-elections';

  let modalState: { isOpen: boolean } = { isOpen: false };
  Logger.log('modalState', modalState);
  modalStore.subscribe((value) => (modalState = value));

  const sendPortalOpenEvent = () => {
    const isFirstTimeUser = PersistentStore.get('isFirstTimeUser');
    if (!isFirstTimeUser) {
      PersistentStore.set('isFirstTimeUser', true);
      sendAnalyticsEvent(EventNames.PORTAL_FIRST_OPEN);
    } else {
      sendAnalyticsEvent(EventNames.PORTAL_OPEN);
    }
  };

  // let utm_source = '';

  onMount(async () => {
    if (pwaInfo) {
      const { registerSW } = await import('virtual:pwa-register');
      registerSW({
        immediate: true,
        onRegistered(r) {
          // uncomment following code if you want check for updates
          // r && setInterval(() => {
          //    Logger.log('Checking for sw update')
          //    r.update()
          // }, 20000 /* 20s for testing purposes */)
          Logger.log(`SW Registered: ${r}`);
        },
        onRegisterError(error) {
          Logger.log('SW registration error', error);
        }
      });
    }
    let urlParams = new URLSearchParams(window.location.search);
    // utm_source = urlParams.get('utm_source') || '';
    // let user_id = urlParams.get('u') || '';

    sendPortalOpenEvent();
    // commenting TWA params for now
    // sendParamsToTWA(utm_source, user_id);
    // sendMoeUniqueId('moe_database', 'moe_data');
  });

  $: webManifestLink = pwaInfo ? pwaInfo.webManifest.linkTag : '';

  // let showSearchAndQuickLinks = false;
  let showSideDrawer = false;

  const sortByRank = (a: Category, b: Category) => a.rank - b.rank;
  const isEnabled = (category: Category) => category.enabled;
  const categories = DRAWER_NAVBAR.sort(sortByRank).filter(isEnabled);
</script>

{#if data}
  <AppHead locals={data?.locals?.config} />
{/if}
<svelte:head>
  <!-- eslint-disable-next-line svelte/no-at-html-tags -->
  {@html webManifestLink}
</svelte:head>

{#if !$page.url.pathname.includes(noNavRoutes)}
  <Header bind:showSideDrawer source={data?.locals?.config?.source} />
{/if}

<!-- <WelcomeBanner /> -->
<!-- <GoogleSearchBox /> -->

{#if showSideDrawer}
  <Drawer {categories} bind:showSideDrawer source={data?.locals?.config?.source} />
{/if}
<!-- //! lets figure out a way to better handle styles -->
<main>
  <slot />
</main>
{#if !$page.url.pathname.includes(noNavRoutes)}
  <CookiePolicy />
  <GoogleAnalytics />
  <PageViewAnalytics />
{/if}

<Toast
  isToastVisible={$isToastVisible}
  toastHeading={$toastHeading}
  toastVarient={$toastVarient}
  size={$toastSize}
  redirectUrl={$toastRedirectURL}
/>

<AgeGatingModal showModal={modalState.isOpen} />

<!-- </div> -->

<style lang="scss">
  @import '../lib/styles/main.scss';
</style>
